module.exports = wp["editor"];